import * as LucideIcons from 'lucide-react'

const iconMap: Record<string, React.ComponentType<any>> = {
  Settings: LucideIcons.Settings,
  Users: LucideIcons.Users,
  MessageCircle: LucideIcons.MessageCircle,
  Target: LucideIcons.Target,
  FileText: LucideIcons.FileText,
  BarChart3: LucideIcons.BarChart3,
  DollarSign: LucideIcons.DollarSign,
  UserCheck: LucideIcons.UserCheck,
  User: LucideIcons.User,
  Shield: LucideIcons.Shield,
  Lock: LucideIcons.Lock,
  Award: LucideIcons.Award,
  Star: LucideIcons.Star,
  TrendingUp: LucideIcons.TrendingUp,
  Briefcase: LucideIcons.Briefcase,
  Heart: LucideIcons.Heart,
  Zap: LucideIcons.Zap,
  BookOpen: LucideIcons.BookOpen,
}

export const getIconComponent = (iconName: string): React.ComponentType<any> => {
  return iconMap[iconName] || LucideIcons.FileText
}
